// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"377":"chat","884":"admin"}[chunkId] || chunkId) + "-styles." + {"377":"ddb5fa430fef17b1ec60","754":"066b334aa92755e0220c","884":"052a0fe1379b08b96c21"}[chunkId] + ".css";
};